<template>
  <div id="form-sidenav">
    <Tabs :labels="[$t('form-side-nav.layout'), $t('form-side-nav.config')]">
      <Layout :id="active.id" :currentView="currentView" :options="options" />
      <Content :id="active.id" :currentView="currentView" :items="items" />
    </Tabs>
  </div>
</template>

<script>
import Mixin from '@/components/sidenav/landing/Mixin.js'
import Content from '@/components/sidenav/landing/form/Content'
import Layout from '@/components/sidenav/landing/form/Layout'

export default {
  name: 'FormSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing' },
  mixins: [Mixin],
  components: { Content, Layout },
  computed: {
    items() {
      const children = [...this.options.items].map(item => ({
        id: item.id,
        title: item.options.label || this.translateFormItemFromType(item.type),
        cantRemove: item.options.cantRemove,
        size: item.options.size[this.currentView],
        position: item.options.position[this.currentView],
        item,
      }))
      return children.sort((i1, i2) => i1.position - i2.position)
    },
  },
  methods: {
    translateFormItemFromType(formItemType) {
      const lowerCaseFormItem = formItemType.toLowerCase()
      return this.$t(`form.form-item.${lowerCaseFormItem}.fallbackLabel`)
    },
  },
}
</script>
